export default __webpack_public_path__ + "media/babb73bf394954fa8ee37c77ac4652b217aa6d1cdeeaaad35d380efb43643861.svg";